<template>
  <Icon>
    <template #component>
      <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
        <path
          d="M610.27,876.17V342c0-27.64,2.14-47.2,6.41-58.8s14.31-21.52,30-29.79,37.22-13.46,64.52-15.69V215.82H477V237.7q38.1,0,65.21,10c18.12,6.68,30.06,15.7,36,27.12s8.83,31.45,8.83,60V720.94L204.65,215.82H14.21V237.7q51.92,0,66.88,7.15T103,277.23q6.9,25.22,6.93,99.49V719q0,58.61-4.51,74.28t-28.8,29.26Q52.28,836.15,6.13,839.47v21.87H247.05V839.47q-51.42,0-77.15-14.78t-31.17-32.36q-5.5-17.62-5.47-73.35V271L589.84,876.16Z"
          transform="translate(-6.13 -215.78)"
          fill="#currentColor"
        />
        <path
          d="M711.75,537.79q112.66,0,157.36,38.32t44.73,119.28q0,79.08-39.54,118.58T755.73,853.5q-44.46,0-59.55-13t-18.54-38.09q-3.48-25.08-3.47-118.12V538.73c13.23-.61,25.72-.94,37.57-.94M674.21,240.86c13.51-1,26.66-1.44,39.52-1.44q74.14,0,104.75,15.18t45.93,43.15q15.33,27.94,15.33,79.05,0,73.31-39,106.05T695,515.64c-5.62,0-12.53-.14-20.76-.46ZM937.28,472.22q47.18-38.55,47.19-102.2,0-154.24-274.69-154.24l-125.5,3.86-107.34,2.55v22.16l23,.32c33.91,0,42.87,2.88,52.9,8.68s16.64,16.41,19.79,31.82,4.7,49.65,4.7,102.65V705.93q0,81.95-4.47,104.37t-21,33q-16.57,10.59-59.54,10.58h-25.7v22.16H729.53q98.29,0,156.85-13.75T982.47,804Q1020,759.4,1020,697.71q0-70.85-55.32-118.11T795.2,524.18q95-13.31,142.08-52"
          transform="translate(-6.13 -215.78)"
          fill="#currentColor"
        />
      </svg>
    </template>
  </Icon>
</template>
<script lang="ts">
interface size {
  height: number;
  width: number;
}
import { defineComponent } from "vue";
import Icon from "@ant-design/icons-vue";
export default defineComponent({
  components: {
    Icon,
  },
});
</script>
<style scoped>
.custom-icons-list :deep(.anticon) {
  margin-right: 6px;
}
</style>
